// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"31d6cfe0","167":"67e28cee"}[chunkId] + ".chunk.css";
};